import React, { lazy } from 'react';
import { FadeIn } from './ui/FadeIn';
const galleryItems = [{
  id: 1,
  src: 'https://cdn.magicpatterns.com/uploads/kzjSnTacTYKxM2nx8o8K4h/Captura_de_pantalla_2026-06-19_122459.png',
  alt: 'Volkswagen Amarok detallada por Morello Detailing'
}, {
  id: 2,
  src: 'https://cdn.magicpatterns.com/uploads/jmhszzLw7wtRBrPTcKCmD8/Captura_de_pantalla_2026-06-19_122742.png',
  alt: 'Honda HR-V detallada por Morello Detailing'
}, {
  id: 3,
  src: 'https://cdn.magicpatterns.com/uploads/aBGNDwibnDqvLzfQuZJADb/Captura_de_pantalla_2026-06-19_122651.png',
  alt: 'Mercedes-Benz Clase E detallado por Morello Detailing'
}, {
  id: 4,
  src: 'https://cdn.magicpatterns.com/uploads/auh4DQeSDTVFRSxsGv8c7t/Captura_de_pantalla_2026-06-19_122630.png',
  alt: 'Mercedes-Benz Clase C detallado por Morello Detailing'
}, {
  id: 5,
  src: 'https://cdn.magicpatterns.com/uploads/ekwP7UkFA75d9av2tW8npE/Captura_de_pantalla_2026-06-19_122615.png',
  alt: 'BMW Z4 detallado por Morello Detailing'
}];
export function Gallery() {
  return <section className="py-16 bg-brand-dark relative" data-id="element-43">
      <div className="container mx-auto px-4 md:px-6" data-id="element-44">
        <FadeIn className="text-center mb-10" data-id="element-45">
          <h2 className="text-3xl md:text-5xl font-bold mb-4" data-id="element-46">
            Galería de <span className="text-brand-red" data-id="element-47">Trabajos</span>
          </h2>
          <p className="text-brand-silver text-lg mb-4" data-id="element-48">
            Resultados reales de nuestros servicios.
          </p>
          <div className="inline-block bg-brand-red/10 text-brand-red px-4 py-2 text-sm font-medium border border-brand-red/20 mb-6" data-id="element-49">
            📸 Fotos reales de vehículos atendidos por Morello Detailing.
          </div>
          <div className="w-24 h-1 bg-brand-red mx-auto mt-4" data-id="element-50"></div>
        </FadeIn>

        <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6" data-id="element-51">
          {galleryItems.map((item, index) => <FadeIn key={item.id} delay={0.08 * (index % 3)} className={`relative group overflow-hidden rounded-sm border border-white/5 bg-brand-darker ${index === 0 ? 'sm:col-span-2 lg:col-span-2 lg:row-span-2' : ''}`} data-id="element-52">
              <img src={item.src} alt={item.alt} loading="lazy" className="w-full h-64 sm:h-72 lg:h-full object-cover transition-transform duration-700 group-hover:scale-105 [filter:brightness(1.18)_contrast(1.06)_saturate(1.12)]" data-id="element-53" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent opacity-60 group-hover:opacity-30 transition-opacity duration-500" data-id="element-54"></div>
              <div className="absolute bottom-0 left-0 right-0 p-4 translate-y-2 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500" data-id="element-55">
                <span className="inline-block bg-brand-red text-white font-heading tracking-widest px-3 py-1 text-xs shadow-lg" data-id="element-56">
                  MORELLO DETAILING
                </span>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}